//
import endpoints from '../endpoints';

import WebMethodService from '../WebMethodService';

class ConsoleAPI {
  static getLanguage () {
    return WebMethodService.callWebMethod(endpoints.console.getLanguage, {});
  }

  static getPendoSettings () {
    return WebMethodService.callWebMethod(endpoints.console.getPendoSettings, {});
  }
}

export default ConsoleAPI;
